import React from 'react'

import { t } from 'src/lib/i18n-react'
import { Image } from '@chatterbug/aaron'
import { getTitleText } from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'

import AchievementWidgetHeaderSkeleton from './AchievementWidgetHeaderSkeleton'

const AchievementWidgetHeader = ({ widgetType }) => {
  const getIcon = (type) => {
    return (
      {
        liveLesson: require('./assets/livelesson.svg'),
        concept: require('./assets/concept.svg'),
        media: require('./assets/media.svg'),
        writing: require('./assets/writing.svg'),
      }[type] || require('./assets/writing.svg')
    )
  }

  return (
    <AchievementWidgetHeaderSkeleton
      nameSection={getTitleText(widgetType)}
      icon={<Image src={getIcon(widgetType)} />}
    />
  )
}

export default AchievementWidgetHeader
